var _circle, _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28",
    className: "shrink-0",
    style: {
      width: 27.96,
      height: 27.96
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.464,
    cy: 24.485,
    r: 3.495,
    fill: "#2E2E2E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.825,
    height: 23.301,
    y: 0.02,
    fill: "#2E2E2E",
    rx: 2.913
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.825,
    height: 23.301,
    x: 12.816,
    y: 4.68,
    fill: "#2E2E2E",
    rx: 2.913
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2E2E",
    d: "M5.828 8.175v1.517c0 .848.502 1.615 1.278 1.956a5.34 5.34 0 0 0 4.115.073l.244-.096a2.145 2.145 0 0 0 1.353-1.994v8.738c0-.88-.536-1.67-1.353-1.994l-.244-.096a5.34 5.34 0 0 0-4.115.073 2.136 2.136 0 0 0-1.278 1.956v1.517-11.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ac0af92ff9c2c0b3a9d164741ab471f6.svg";
export { ForwardRef as ReactComponent };